import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../../hooks/useQuiz';
import { LeadCaptureForm } from '../lead/LeadCaptureForm';
import { ProgressBar } from './ProgressBar';
import { QuestionCard } from './QuestionCard';

export function QuizContainer() {
  const navigate = useNavigate();
  const {
    state,
    currentQuestion,
    questionNumber,
    totalQuestions,
    startQuiz,
    selectAnswer,
    goToPrevious,
    submitLead,
  } = useQuiz();

  useEffect(() => {
    if (state.phase === 'intro') {
      startQuiz();
    }
  }, [state.phase, startQuiz]);

  useEffect(() => {
    if (state.phase === 'complete' && state.submissionId) {
      navigate(`/result/${state.submissionId}`);
    }
  }, [state.phase, state.submissionId, navigate]);

  if (state.phase === 'lead_capture' || state.phase === 'submitting') {
    return (
      <LeadCaptureForm
        onSubmit={submitLead}
        onBack={goToPrevious}
        isSubmitting={state.phase === 'submitting'}
        error={state.error}
      />
    );
  }

  if (state.phase === 'error') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <p className="text-red-700 font-medium mb-4">{state.error}</p>
        <button
          onClick={goToPrevious}
          className="text-sm text-red-600 underline hover:text-red-800"
        >
          Go back and try again
        </button>
      </div>
    );
  }

  if (!currentQuestion) return null;

  return (
    <div>
      <ProgressBar current={questionNumber} total={totalQuestions} />

      <div className="bg-white rounded-xl shadow-sm border border-cream/40 p-6 sm:p-8">
        <h2 className="text-xl font-semibold text-brand mb-6">
          Question {questionNumber}
        </h2>
        <QuestionCard
          key={currentQuestion.id}
          question={currentQuestion}
          selectedOption={state.answers[state.currentIndex]}
          onSelect={selectAnswer}
        />
      </div>

      {questionNumber > 1 && (
        <div className="mt-4 flex justify-start">
          <button
            onClick={goToPrevious}
            className="text-sm text-brand-slate hover:text-brand flex items-center gap-1 transition-colors"
          >
            <span aria-hidden>←</span> Previous question
          </button>
        </div>
      )}
    </div>
  );
}
